import call from '../utils/call';
export default function promise() {
    return {
        validate(input) {
            return call(input.options.promise, [input]);
        },
    };
}



// WEBPACK FOOTER //
// ./node_modules/formvalidation/dist/es6/validators/promise.js